import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MonteCarlo.css';
import { useLanguage } from '../LanguageContext';

const MonteCarlo = () => {
  const { language } = useLanguage();
  const [trials, setTrials] = useState(50000);
  const [estimate, setEstimate] = useState(null);
  const [inside, setInside] = useState(null);
  const [duration, setDuration] = useState(null);
  const [running, setRunning] = useState(false);

  const translations = {
    title: language === 'ar' ? 'مونتي كارلو' : language === 'fr' ? 'Monte Carlo' : 'Monte Carlo',
    description:
      language === 'ar'
        ? 'تقدير قيمة π باستخدام محاكاة مونتي كارلو عبر نقاط عشوائية داخل مربع.'
        : language === 'fr'
        ? 'Estimez la valeur de π avec une simulation Monte Carlo utilisant des points aléatoires.'
        : 'Estimate π using a Monte Carlo simulation with random points.',
    trialsLabel: language === 'ar' ? 'عدد المحاولات' : language === 'fr' ? 'Nombre d’essais' : 'Number of trials',
    runButton: language === 'ar' ? 'تشغيل المحاكاة' : language === 'fr' ? 'Lancer la simulation' : 'Run simulation',
    resultTitle: language === 'ar' ? 'النتائج' : language === 'fr' ? 'Résultats' : 'Results',
    estimateLabel: language === 'ar' ? 'التقدير' : language === 'fr' ? 'Estimation' : 'Estimated value',
    insideLabel: language === 'ar' ? 'نقاط داخل الربع الدائرة' : language === 'fr' ? 'Points à l’intérieur' : 'Points inside circle',
    durationLabel: language === 'ar' ? 'مدة المحاكاة' : language === 'fr' ? 'Durée de la simulation' : 'Simulation time',
    explanation:
      language === 'ar'
        ? 'المحاكاة تولّد نقاطاً عشوائية داخل مربع وحدوي وتحسب نسبة النقاط داخل ربع دائرة لاحتساب π.'
        : language === 'fr'
        ? 'La simulation génère des points aléatoires dans un carré unité et calcule la proportion à l’intérieur du quart de cercle pour estimer π.'
        : 'The simulation generates random points inside a unit square and calculates the proportion inside a quarter circle to estimate π.',
    homeLink: language === 'ar' ? 'العودة إلى الصفحة الرئيسية' : language === 'fr' ? 'Retour à l’accueil' : 'Back to home',
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const count = Math.max(1000, Math.min(1000000, Number(trials) || 50000));
    setTrials(count);
    setRunning(true);
    setEstimate(null);
    setInside(null);
    setDuration(null);

    window.requestAnimationFrame(() => {
      const start = performance.now();
      let insideCount = 0;
      for (let i = 0; i < count; i += 1) {
        const x = Math.random();
        const y = Math.random();
        if (x * x + y * y <= 1) {
          insideCount += 1;
        }
      }
      const end = performance.now();
      setInside(insideCount);
      setEstimate((4 * insideCount) / count);
      setDuration((end - start).toFixed(2));
      setRunning(false);
    });
  };

  return (
    <div className="monte-carlo-page" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="monte-carlo-card">
        <h1>{translations.title}</h1>
        <p>{translations.description}</p>

        <form onSubmit={handleSubmit} className="monte-carlo-form">
          <label htmlFor="trials-input">{translations.trialsLabel}</label>
          <input
            id="trials-input"
            type="number"
            value={trials}
            min="1000"
            max="1000000"
            step="1000"
            onChange={(e) => setTrials(e.target.value)}
          />
          <button type="submit" disabled={running}>
            {running ? (language === 'ar' ? 'جارٍ الحساب...' : language === 'fr' ? 'Calcul en cours...' : 'Running...') : translations.runButton}
          </button>
        </form>

        {estimate !== null && (
          <div className="monte-carlo-result">
            <h2>{translations.resultTitle}</h2>
            <div className="result-row">
              <span>{translations.estimateLabel}:</span>
              <strong>{estimate.toFixed(6)}</strong>
            </div>
            <div className="result-row">
              <span>{translations.insideLabel}:</span>
              <strong>{inside}</strong>
            </div>
            <div className="result-row">
              <span>{translations.durationLabel}:</span>
              <strong>{duration} ms</strong>
            </div>
          </div>
        )}

        <p className="monte-carlo-explanation">{translations.explanation}</p>
        <Link to="/" className="monte-carlo-home-link">
          {translations.homeLink}
        </Link>
      </div>
    </div>
  );
};

export default MonteCarlo;
